"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5676],{

/***/ 60181:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m12 8-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

exports.Z = _default;

/***/ }),

/***/ 40470:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
}), 'InsertLink');

exports.Z = _default;

/***/ }),

/***/ 76218:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06 4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
}), 'MoneyOff');

exports.Z = _default;

/***/ }),

/***/ 96198:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5H9z"
}), 'NorthEast');

exports.Z = _default;

/***/ }),

/***/ 42761:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

exports.Z = _default;

/***/ }),

/***/ 96031:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
}), 'VerticalAlignTop');

exports.Z = _default;

/***/ }),

/***/ 44731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Avatar_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(1048);
// EXTERNAL MODULE: ./node_modules/@mui/material/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(32793);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(94780);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/styled.js
var styled = __webpack_require__(81719);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useThemeProps.js
var useThemeProps = __webpack_require__(78884);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(54235);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/internal/svg-icons/Person.js


/**
 * @ignore - internal component.
 */


/* harmony default export */ var Person = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(34867);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(1588);
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Avatar/avatarClasses.js

function getAvatarUtilityClass(slot) {
  return (0,generateUtilityClass/* default */.Z)('MuiAvatar', slot);
}
const avatarClasses = (0,generateUtilityClasses/* default */.Z)('MuiAvatar', ['root', 'colorDefault', 'circular', 'rounded', 'square', 'img', 'fallback']);
/* harmony default export */ var Avatar_avatarClasses = ((/* unused pure expression or super */ null && (avatarClasses)));
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js


const _excluded = ["alt", "children", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"];










const useUtilityClasses = ownerState => {
  const {
    classes,
    variant,
    colorDefault
  } = ownerState;
  const slots = {
    root: ['root', variant, colorDefault && 'colorDefault'],
    img: ['img'],
    fallback: ['fallback']
  };
  return (0,composeClasses/* default */.Z)(slots, getAvatarUtilityClass, classes);
};

const AvatarRoot = (0,styled/* default */.ZP)('div', {
  name: 'MuiAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.colorDefault && styles.colorDefault];
  }
})(({
  theme,
  ownerState
}) => (0,esm_extends/* default */.Z)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: '50%',
  overflow: 'hidden',
  userSelect: 'none'
}, ownerState.variant === 'rounded' && {
  borderRadius: (theme.vars || theme).shape.borderRadius
}, ownerState.variant === 'square' && {
  borderRadius: 0
}, ownerState.colorDefault && (0,esm_extends/* default */.Z)({
  color: (theme.vars || theme).palette.background.default
}, theme.vars ? {
  backgroundColor: theme.vars.palette.Avatar.defaultBg
} : {
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
})));
const AvatarImg = (0,styled/* default */.ZP)('img', {
  name: 'MuiAvatar',
  slot: 'Img',
  overridesResolver: (props, styles) => styles.img
})({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: 'cover',
  // Hide alt text.
  color: 'transparent',
  // Hide the image broken icon, only works on Chrome.
  textIndent: 10000
});
const AvatarFallback = (0,styled/* default */.ZP)(Person, {
  name: 'MuiAvatar',
  slot: 'Fallback',
  overridesResolver: (props, styles) => styles.fallback
})({
  width: '75%',
  height: '75%'
});

function useLoaded({
  crossOrigin,
  referrerPolicy,
  src,
  srcSet
}) {
  const [loaded, setLoaded] = react.useState(false);
  react.useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    let active = true;
    const image = new Image();

    image.onload = () => {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = () => {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    image.crossOrigin = crossOrigin;
    image.referrerPolicy = referrerPolicy;
    image.src = src;

    if (srcSet) {
      image.srcset = srcSet;
    }

    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}

const Avatar = /*#__PURE__*/react.forwardRef(function Avatar(inProps, ref) {
  const props = (0,useThemeProps/* default */.Z)({
    props: inProps,
    name: 'MuiAvatar'
  });

  const {
    alt,
    children: childrenProp,
    className,
    component = 'div',
    imgProps,
    sizes,
    src,
    srcSet,
    variant = 'circular'
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);

  let children = null; // Use a hook instead of onError on the img element to support server-side rendering.

  const loaded = useLoaded((0,esm_extends/* default */.Z)({}, imgProps, {
    src,
    srcSet
  }));
  const hasImg = src || srcSet;
  const hasImgNotFailing = hasImg && loaded !== 'error';

  const ownerState = (0,esm_extends/* default */.Z)({}, props, {
    colorDefault: !hasImgNotFailing,
    component,
    variant
  });

  const classes = useUtilityClasses(ownerState);

  if (hasImgNotFailing) {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarImg, (0,esm_extends/* default */.Z)({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      ownerState: ownerState,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarFallback, {
      className: classes.fallback
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(AvatarRoot, (0,esm_extends/* default */.Z)({
    as: component,
    ownerState: ownerState,
    className: (0,clsx_m/* default */.Z)(classes.root, className),
    ref: ref
  }, other, {
    children: children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Avatar_Avatar = (Avatar);

/***/ }),

/***/ 49825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Br": function() { return /* binding */ companyNameContainerStyles; },
/* harmony export */   "D$": function() { return /* binding */ companyTypeChip; },
/* harmony export */   "Fc": function() { return /* binding */ containerStyles; },
/* harmony export */   "mF": function() { return /* binding */ statsContainerStyles; },
/* harmony export */   "q0": function() { return /* binding */ companyAvatarStyles; }
/* harmony export */ });
/* unused harmony export sellersAvatarStyles */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var companyAvatarStyles = {
    backgroundColor: "#3A3E50",
    // backgroundColor: '#13628C',
    padding: "1.5em",
    fontWeight: 700
};
var containerStyles = {
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxShadow: "0px 8px 32px 0px #EBEBEB",
    padding: "1.5rem",
    height: "100%",
    width: "100%"
};
var companyNameContainerStyles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, containerStyles), {
    padding: "2rem 1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem"
});
var statsContainerStyles = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, containerStyles), {
    display: "grid"
});
var companyTypeChip = {
    paddingInline: "1rem",
    paddingBlock: "1em",
    backgroundColor: "#EAEEF6",
    color: "#13628C",
    fontWeight: 500
};
var sellersAvatarStyles = {
    backgroundColor: "#D0E0E8",
    padding: "1.5em",
    fontWeight: 700,
    color: "#13628C",
    transition: "background-color 200ms, color 200ms"
};


/***/ }),

/***/ 9146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14398);
/* harmony import */ var _form_header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73383);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79072);





var FormWithSummaryLayout = function(param) {
    var children = param.children, _canViewCatalog = param.canViewCatalog, canViewCatalog = _canViewCatalog === void 0 ? false : _canViewCatalog;
    var environment = (0,_zustand__WEBPACK_IMPORTED_MODULE_2__/* .useProcurementStore */ .fp)(function(state) {
        return state.productFormManagerProperties.data.environment;
    });
    // const { setEnvironmentFilters } = useAdvancedFiltersSlice(state => state.actions);
    // const envFilters = useEnvironmentFilters();
    // const hasPageBeenRendered = React.useRef<boolean>(false);
    // React.useEffect(() => {
    //   if (hasPageBeenRendered.current) {
    //     setEnvironmentFilters(envFilters, true);
    //   }
    //   hasPageBeenRendered.current = true;
    // }, [envFilters]);
    if (!environment) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
            container: true,
            sx: {
                width: "100%"
            },
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
        container: true,
        sx: {
            width: "calc(100% - 350px)"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form_header__WEBPACK_IMPORTED_MODULE_3__/* .FormProductManagerHeader */ .k, {
                canViewCatalog: canViewCatalog
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormWithSummaryLayout);


/***/ }),

/***/ 46242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _tmp_build_5127cbf7_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_5127cbf7_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_5127cbf7_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14398);
/* harmony import */ var _mui_lab__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(44518);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29630);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_logic_services_catalogue_brands__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87595);
/* harmony import */ var src_logic_utils_numbers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(38738);
/* harmony import */ var src_logic_zustand_Filters_hooks_use_environment_filters__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32247);
/* harmony import */ var _components_InfoPopperList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69302);
/* harmony import */ var _components_Label__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93704);
/* harmony import */ var _components_VerticalDivider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(38750);













var BrandBanner = function(param) {
    var brand = param.brand, _disableFetch = param.disableFetch, disableFetch = _disableFetch === void 0 ? false : _disableFetch;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var isBuyer = _zustand__WEBPACK_IMPORTED_MODULE_2__/* .useUserData.getState */ .v$.getState().isBuyer();
    var environmentFilters = (0,src_logic_zustand_Filters_hooks_use_environment_filters__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var _slug;
    var ref8 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_8__.useQuery)({
        queryKey: [
            "BRAND_BANNER",
            (_slug = brand.slug) !== null && _slug !== void 0 ? _slug : brand.id,
            {
                environmentFilters: environmentFilters
            }
        ],
        queryFn: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_tmp_build_5127cbf7_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data;
            return _tmp_build_5127cbf7_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,src_logic_services_catalogue_brands__WEBPACK_IMPORTED_MODULE_3__/* .getBrandDetailsBanner */ .lk)(brand.slug, {
                            environmentFilters: environmentFilters
                        });
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: 0,
        enabled: !disableFetch
    }), data = ref8.data, _isLoading = ref8.isLoading;
    var brandBannerDetails = disableFetch ? brand : data;
    var isLoading = disableFetch ? false : _isLoading;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        style: {
            width: "100%",
            marginBlock: "1rem",
            backgroundColor: "#fff",
            borderRadius: "8px"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            style: {
                padding: "1.5rem"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "1rem",
                        marginBottom: "1rem"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            src: brand.image_url,
                            alt: brand.name,
                            style: {
                                maxWidth: "100px",
                                maxHeight: "60px",
                                objectFit: "contain"
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            style: {
                                display: "flex",
                                gap: "2rem",
                                alignItems: "center"
                            },
                            children: [
                                (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : brandBannerDetails.sellers) !== undefined && isBuyer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Label__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    label: "Sellers"
                                                }),
                                                isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    loading: true,
                                                    loadingPosition: "start"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    color: "#3A3E50",
                                                    fontSize: 14,
                                                    fontWeight: 600,
                                                    children: [
                                                        (0,src_logic_utils_numbers__WEBPACK_IMPORTED_MODULE_12__/* .formatInteger */ .k)((brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref = brandBannerDetails.sellers) === null || ref === void 0 ? void 0 : ref.length) || 0),
                                                        " ",
                                                        (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref1 = brandBannerDetails.sellers) === null || ref1 === void 0 ? void 0 : ref1.length) !== 1 ? "Sellers" : "Seller",
                                                        " ",
                                                        (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : brandBannerDetails.sellers) && (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref2 = brandBannerDetails.sellers) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_InfoPopperList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            title: (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref3 = brandBannerDetails.sellers) === null || ref3 === void 0 ? void 0 : ref3.length) !== 1 ? "Sellers" : "Seller",
                                                            items: brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : brandBannerDetails.sellers,
                                                            renderItem: function(item) {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    color: "#3A3E50",
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    lineHeight: 1,
                                                                    my: 1,
                                                                    children: item.seller.name
                                                                }, item.seller.id);
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_VerticalDivider__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Label__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    label: "Categories"
                                                }),
                                                isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    loading: true,
                                                    loadingPosition: "start"
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                    color: "#3A3E50",
                                                    fontSize: 14,
                                                    fontWeight: 600,
                                                    children: [
                                                        (0,src_logic_utils_numbers__WEBPACK_IMPORTED_MODULE_12__/* .formatInteger */ .k)((brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref4 = brandBannerDetails.categories) === null || ref4 === void 0 ? void 0 : ref4.length) || 0),
                                                        " ",
                                                        (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref5 = brandBannerDetails.categories) === null || ref5 === void 0 ? void 0 : ref5.length) !== 1 ? "Categories" : "Category",
                                                        " ",
                                                        (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : brandBannerDetails.categories) && (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref6 = brandBannerDetails.categories) === null || ref6 === void 0 ? void 0 : ref6.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_InfoPopperList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            title: (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : (ref7 = brandBannerDetails.categories) === null || ref7 === void 0 ? void 0 : ref7.length) !== 1 ? "Categories" : "Category",
                                                            items: brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : brandBannerDetails.categories,
                                                            renderItem: function(item) {
                                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    color: "#3A3E50",
                                                                    fontWeight: 400,
                                                                    fontSize: 12,
                                                                    lineHeight: 1,
                                                                    my: 1,
                                                                    children: item.name
                                                                }, item.id);
                                                            }
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_VerticalDivider__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Label__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                label: "Products"
                                            }),
                                            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_lab__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                loading: true,
                                                loadingPosition: "start"
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                color: "#3A3E50",
                                                fontSize: 14,
                                                fontWeight: 600,
                                                children: [
                                                    (0,src_logic_utils_numbers__WEBPACK_IMPORTED_MODULE_12__/* .formatInteger */ .k)((brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : brandBannerDetails.number_of_products) || 0),
                                                    " Product",
                                                    (brandBannerDetails === null || brandBannerDetails === void 0 ? void 0 : brandBannerDetails.number_of_products) !== 1 ? "s" : ""
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    color: "#3A3E50",
                    fontWeight: 400,
                    fontSize: 15,
                    children: brand === null || brand === void 0 ? void 0 : brand.description
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BrandBanner);


/***/ }),

/***/ 34226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ catalogue_banner_CatalogueBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/logic/zustand/catalouge/index.ts
var catalouge = __webpack_require__(38611);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-content/utils/number-of-selections.tsx
var number_of_selections = __webpack_require__(86309);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/BrandBanner.tsx
var BrandBanner = __webpack_require__(46242);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/ClassificationBanner.tsx + 2 modules
var ClassificationBanner = __webpack_require__(97327);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/logic/utils/avatar/index.ts
var avatar = __webpack_require__(50332);
// EXTERNAL MODULE: ./src/logic/utils/numbers/index.ts
var numbers = __webpack_require__(38738);
// EXTERNAL MODULE: ./src/site-map.ts
var site_map = __webpack_require__(29951);
// EXTERNAL MODULE: ./src/ui/components/dumb/company-details/shared/styles.ts
var styles = __webpack_require__(49825);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/components/InfoPopperList.tsx
var InfoPopperList = __webpack_require__(69302);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/components/Label.tsx
var Label = __webpack_require__(93704);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/components/VerticalDivider.tsx
var VerticalDivider = __webpack_require__(38750);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(3471);
// EXTERNAL MODULE: ./src/logic/services/catalogue/sellers/index.tsx
var sellers = __webpack_require__(35929);
// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 5 modules
var LoadingButton = __webpack_require__(44518);
;// CONCATENATED MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/SellerBanner.tsx

















var SellerBanner = function(param) {
    var seller = param.seller;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27;
    var sellerId = seller === null || seller === void 0 ? void 0 : (ref = seller.seller) === null || ref === void 0 ? void 0 : ref.id;
    var ref28 = (0,index_production.useQuery)({
        queryKey: [
            "SELLER_BANNER",
            sellerId
        ],
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,sellers/* getSellerDetails */.Ut)(sellerId);
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        enabled: sellerId !== undefined && sellerId !== null,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: 0
    }), sellerDetails = ref28.data, isLoading = ref28.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            marginBlock: "1rem",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: ".75rem 1rem",
            width: "100%",
            display: "flex",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, styles/* companyAvatarStyles */.q0), {
                            padding: "1.75em",
                            fontSize: 14
                        }),
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                            loading: true,
                            loadingPosition: "center"
                        }) : (0,avatar/* getAvatarDisplayName */.y)(sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref1 = sellerDetails.company) === null || ref1 === void 0 ? void 0 : ref1.name)
                    }),
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                        loading: true,
                        loadingPosition: "start"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: site_map.sm.catalogue.sellers.sellerId("".concat(seller.seller.id)).url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "#3A3E50",
                            fontWeight: 700,
                            fontSize: 18,
                            className: "cursor-pointer underline-on-hover",
                            noWrap: true,
                            children: sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref2 = sellerDetails.company) === null || ref2 === void 0 ? void 0 : ref2.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDivider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                label: "Location"
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                loading: true,
                                loadingPosition: "start"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                color: "#3A3E50",
                                fontSize: 14,
                                fontWeight: 600,
                                children: [
                                    sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref3 = sellerDetails.company) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.city) === null || ref4 === void 0 ? void 0 : ref4.name,
                                    " ",
                                    sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref5 = sellerDetails.company) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.country) === null || ref6 === void 0 ? void 0 : ref6.name
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDivider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                label: "Products & Services"
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                loading: true,
                                loadingPosition: "start"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                color: "#3A3E50",
                                fontSize: 14,
                                fontWeight: 600,
                                children: [
                                    (0,numbers/* formatInteger */.k)((sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref7 = sellerDetails.company) === null || ref7 === void 0 ? void 0 : ref7.number_of_products) + (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref8 = sellerDetails.company) === null || ref8 === void 0 ? void 0 : ref8.number_of_services)),
                                    " Products & Services"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDivider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                label: "Categories"
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                loading: true,
                                loadingPosition: "start"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                color: "#3A3E50",
                                fontSize: 14,
                                fontWeight: 600,
                                children: [
                                    (0,numbers/* formatInteger */.k)((sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref9 = sellerDetails.company) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.categories) === null || ref10 === void 0 ? void 0 : ref10.length) || 0),
                                    " ",
                                    (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref11 = sellerDetails.company) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.categories) === null || ref12 === void 0 ? void 0 : ref12.length) !== 1 ? "Categories" : "Category",
                                    " ",
                                    " ",
                                    (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref13 = sellerDetails.company) === null || ref13 === void 0 ? void 0 : ref13.categories) && (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref14 = sellerDetails.company) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.categories) === null || ref15 === void 0 ? void 0 : ref15.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopperList/* default */.Z, {
                                        title: (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref16 = sellerDetails.company) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.categories) === null || ref17 === void 0 ? void 0 : ref17.length) !== 1 ? "Categories" : "Category",
                                        items: sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref18 = sellerDetails.company) === null || ref18 === void 0 ? void 0 : ref18.categories,
                                        renderItem: function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: "#3A3E50",
                                                fontWeight: 400,
                                                fontSize: 12,
                                                lineHeight: 1,
                                                my: 1,
                                                children: item.name
                                            }, item.id);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VerticalDivider/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                label: "Brands"
                            }),
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                loading: true,
                                loadingPosition: "start"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                color: "#3A3E50",
                                fontSize: 14,
                                fontWeight: 600,
                                children: [
                                    (0,numbers/* formatInteger */.k)((sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref19 = sellerDetails.company) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.brands) === null || ref20 === void 0 ? void 0 : ref20.length) || 0),
                                    " Brand",
                                    (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref21 = sellerDetails.company) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.brands) === null || ref22 === void 0 ? void 0 : ref22.length) !== 1 && "s",
                                    " ",
                                    (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref23 = sellerDetails.company) === null || ref23 === void 0 ? void 0 : ref23.brands) && (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref24 = sellerDetails.company) === null || ref24 === void 0 ? void 0 : ref24.brands.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPopperList/* default */.Z, {
                                        title: (sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref25 = sellerDetails.company) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.brands) === null || ref26 === void 0 ? void 0 : ref26.length) !== 1 ? "Brands" : "Brands",
                                        items: sellerDetails === null || sellerDetails === void 0 ? void 0 : (ref27 = sellerDetails.company) === null || ref27 === void 0 ? void 0 : ref27.brands,
                                        renderItem: function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: "#3A3E50",
                                                fontWeight: 400,
                                                fontSize: 12,
                                                lineHeight: 1,
                                                my: 1,
                                                children: item.name
                                            }, item.id);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
        ]
    });
};
/* harmony default export */ var catalogue_banner_SellerBanner = (SellerBanner);

;// CONCATENATED MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/CatalogueBanner.tsx






var allAreZeros = function(arr) {
    return arr.every(function(num) {
        return num === 0;
    });
};
var CatalogueBanner = function() {
    var ref = (0,catalouge/* useCatalogueSlice */.X)(function(state) {
        return state.properties;
    }), selectedGroup = ref.selectedGroup, selectedCategory = ref.selectedCategory, selectedClass = ref.selectedClass, selectedTypes = ref.selectedTypes, selectedBrands = ref.selectedBrands, selectedSellers = ref.selectedSellers;
    var numberOfSelectedClassifications = (0,number_of_selections/* useNumberOfSelectedClassifications */.by)();
    var numberOfSelectedBrands = (0,number_of_selections/* useNumberOfSelectedBrands */.fT)();
    var numberOfSelectedSellers = (0,number_of_selections/* useNumberOfSelectedSellers */.zi)();
    var totalNumberOfSelections = (0,number_of_selections/* useTotalNumberOfSelections */.uo)();
    if (totalNumberOfSelections === 0) {
        return null;
    }
    var banners = [
        {
            condition: function() {
                return numberOfSelectedBrands === 1 && allAreZeros([
                    numberOfSelectedClassifications,
                    numberOfSelectedSellers
                ]);
            },
            content: function() {
                return selectedBrands[0] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandBanner/* default */.Z, {
                    brand: selectedBrands[0]
                }) : null;
            }
        },
        {
            condition: function() {
                return numberOfSelectedSellers === 1 && allAreZeros([
                    numberOfSelectedClassifications,
                    numberOfSelectedBrands
                ]);
            },
            content: function() {
                return selectedSellers[0] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(catalogue_banner_SellerBanner, {
                    seller: selectedSellers[0]
                }) : null;
            }
        },
        {
            condition: function() {
                return selectedTypes.length === 1 && allAreZeros([
                    numberOfSelectedBrands,
                    numberOfSelectedSellers
                ]);
            },
            content: function() {
                return selectedTypes[0] ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassificationBanner/* default */.Z, {
                    category: selectedTypes[0]
                }) : null;
            }
        },
        {
            condition: function() {
                return Boolean(selectedClass) && allAreZeros([
                    numberOfSelectedBrands,
                    numberOfSelectedSellers,
                    selectedTypes.length
                ]);
            },
            content: function() {
                return selectedClass ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassificationBanner/* default */.Z, {
                    category: selectedClass
                }) : null;
            }
        },
        {
            condition: function() {
                return Boolean(selectedCategory) && allAreZeros([
                    numberOfSelectedBrands,
                    numberOfSelectedSellers,
                    selectedTypes.length
                ]);
            },
            content: function() {
                return selectedCategory ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassificationBanner/* default */.Z, {
                    category: selectedCategory
                }) : null;
            }
        },
        {
            condition: function() {
                return Boolean(selectedGroup) && allAreZeros([
                    numberOfSelectedBrands,
                    numberOfSelectedSellers,
                    selectedTypes.length
                ]);
            },
            content: function() {
                return selectedGroup ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClassificationBanner/* default */.Z, {
                    category: selectedGroup
                }) : null;
            }
        }, 
    ];
    var bannerToShow = banners.find(function(banner) {
        return banner.condition();
    });
    return bannerToShow ? bannerToShow.content() : null;
};
/* harmony default export */ var catalogue_banner_CatalogueBanner = (CatalogueBanner);


/***/ }),

/***/ 97327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ catalogue_banner_ClassificationBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/OpenInNew.js
var OpenInNew = __webpack_require__(54048);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 1 modules
var Button = __webpack_require__(54225);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/logic/hooks/use-popup/index.ts
var use_popup = __webpack_require__(19895);
// EXTERNAL MODULE: ./src/logic/helpers/index.ts + 2 modules
var helpers = __webpack_require__(31176);
;// CONCATENATED MODULE: ./src/logic/services/catalogue/faqs.ts

var getCategoryFaqs = function(categoryId) {
    return (0,helpers/* request */.WY)({
        url: "/categories/".concat(categoryId, "/faqs"),
        method: "GET"
    });
};

// EXTERNAL MODULE: ./src/site-map.ts
var site_map = __webpack_require__(29951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ExpandMore.js
var ExpandMore = __webpack_require__(23508);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Accordion/Accordion.js + 1 modules
var Accordion = __webpack_require__(76992);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(29618);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(47028);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(29620);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(3471);
// EXTERNAL MODULE: ./node_modules/html-react-parser/esm/index.mjs
var esm = __webpack_require__(47311);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-content/components/EmptySection.tsx
var EmptySection = __webpack_require__(74887);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-content/components/ErrorSection.tsx
var ErrorSection = __webpack_require__(70833);
// EXTERNAL MODULE: ./src/ui/components/smart/catalogue/catalogue-content/components/LoadingSection.tsx
var LoadingSection = __webpack_require__(17641);
;// CONCATENATED MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/FaqPopup.tsx














var FaqPopup = function(param) {
    var open = param.open, onClose = param.onClose, queryKey = param.queryKey, fetchFaqs = param.fetchFaqs;
    var ref;
    // undefined = no user interaction yet → default to first item
    // null      = user explicitly collapsed all
    // number    = user opened a specific item
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(undefined), 2), userSelectedId = ref1[0], setUserSelectedId = ref1[1];
    var ref2 = (0,index_production.useQuery)({
        queryKey: queryKey,
        queryFn: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return fetchFaqs();
                    case 2:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        enabled: open,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: 0
    }), faqs = ref2.data, isLoading = ref2.isLoading, isError = ref2.isError, refetch = ref2.refetch;
    var ref3;
    var expandedId = userSelectedId === undefined ? (ref3 = faqs === null || faqs === void 0 ? void 0 : (ref = faqs[0]) === null || ref === void 0 ? void 0 : ref.id) !== null && ref3 !== void 0 ? ref3 : false : userSelectedId !== null && userSelectedId !== void 0 ? userSelectedId : false;
    react.useEffect(function() {
        if (!open) setUserSelectedId(undefined);
    }, [
        open
    ].concat((0,_to_consumable_array/* default */.Z)(queryKey)));
    var handleAccordionChange = function(faqId) {
        return function(_, isExpanded) {
            setUserSelectedId(isExpanded ? faqId : null);
        };
    };
    var renderContent = function() {
        if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSection/* default */.Z, {
            label: "Loading FAQs...",
            minHeight: "200px"
        });
        if (isError) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorSection/* default */.Z, {
            refetch: refetch,
            minHeight: "200px"
        });
        if (!faqs || faqs.length === 0) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptySection/* default */.Z, {
                hideQuestion: true,
                text: "No FAQs available"
            });
        }
        return faqs.map(function(faq, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                expanded: expandedId === faq.id,
                onChange: handleAccordionChange(faq.id),
                disableGutters: true,
                square: true,
                elevation: 0,
                sx: {
                    borderBottom: "1px solid #EBEBEB",
                    boxShadow: "none",
                    "&::before": {
                        display: "none"
                    },
                    "&.Mui-expanded": {
                        backgroundColor: "#F8F9FC"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandMore/* default */.Z, {
                            sx: {
                                color: "#8B8D98"
                            }
                        }),
                        sx: {
                            px: 3,
                            py: 1.5,
                            minHeight: "unset",
                            "& .MuiAccordionSummary-content": {
                                my: 0
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            fontWeight: 500,
                            fontSize: 14,
                            color: "#3A3E50",
                            children: [
                                index + 1,
                                ". ",
                                faq.question
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        sx: {
                            px: 3,
                            pt: 0,
                            pb: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            component: "div",
                            color: "#8B8D98",
                            fontSize: 13,
                            lineHeight: 1.6,
                            children: (0,esm/* default */.ZP)(faq.answer)
                        })
                    })
                ]
            }, faq.id);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        open: open,
        onClose: onClose,
        fullWidth: true,
        PaperProps: {
            sx: {
                width: "560px",
                maxWidth: "560px",
                borderRadius: "12px"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
                component: "div",
                sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 3,
                    py: 2,
                    borderBottom: "1px solid #EBEBEB"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        fontWeight: 700,
                        fontSize: 18,
                        color: "#3A3E50",
                        children: "FAQ"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: onClose,
                        size: "small",
                        "aria-label": "Close FAQ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            sx: {
                                color: "#8B8D98",
                                fontSize: 18
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                sx: {
                    px: 0,
                    py: 0,
                    maxHeight: "60vh",
                    overflowY: "auto"
                },
                children: renderContent()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions/* default */.Z, {
                sx: {
                    px: 3,
                    py: 2,
                    borderTop: "1px solid #EBEBEB"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    variant: "contained",
                    color: "primary",
                    onClick: onClose,
                    children: "Close"
                })
            })
        ]
    });
};
/* harmony default export */ var catalogue_banner_FaqPopup = (FaqPopup);

;// CONCATENATED MODULE: ./src/ui/components/smart/catalogue/catalogue-banner/ClassificationBanner.tsx










var ClassificationBanner = function(param) {
    var category = param.category;
    var faqPopup = (0,use_popup/* default */.Z)();
    var pathname = (0,router.useRouter)().pathname;
    var isOnCategoryPage = pathname === site_map.sm.catalogue.categories.categoryId("[id]").url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    marginBlock: "1rem",
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    padding: "1.5rem",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "1em"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                color: "#3A3E50",
                                fontWeight: 700,
                                fontSize: 21,
                                children: category.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "1rem"
                                },
                                children: [
                                    !isOnCategoryPage && category.slug && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: site_map.sm.catalogue.categories.categoryId(category.slug).url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            type: "button",
                                            color: "primary",
                                            variant: "text",
                                            sx: {
                                                fontWeight: 700,
                                                fontSize: 14
                                            },
                                            endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInNew/* default */.Z, {
                                                fontSize: "inherit"
                                            }),
                                            children: "Link"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        color: "#8B8D98",
                                        fontWeight: 500,
                                        fontSize: 14,
                                        children: [
                                            "Need help?",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                type: "button",
                                                color: "primary",
                                                variant: "text",
                                                sx: {
                                                    fontWeight: 700,
                                                    fontSize: 14
                                                },
                                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {}),
                                                onClick: faqPopup.handleOpen,
                                                children: "Read FAQ"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    category.description ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        mt: 1,
                        fontWeight: 400,
                        fontSize: 12,
                        color: "#8B8D98",
                        children: category.description
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(catalogue_banner_FaqPopup, {
                open: faqPopup.isOpen,
                onClose: faqPopup.handleClose,
                queryKey: [
                    "CATEGORY_FAQS",
                    category.id
                ],
                fetchFaqs: function() {
                    return getCategoryFaqs(category.id);
                }
            })
        ]
    });
};
/* harmony default export */ var catalogue_banner_ClassificationBanner = (ClassificationBanner);


/***/ }),

/***/ 69302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2548);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44373);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_logic_hooks_use_popup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19895);
/* harmony import */ var src_ui_components_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65058);







var InfoPopperList = function(param) {
    var title = param.title, items = param.items, renderItem = param.renderItem;
    var anchorRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var popper = (0,src_logic_hooks_use_popup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                style: {
                    all: "unset",
                    cursor: "pointer"
                },
                ref: anchorRef,
                onClick: popper.handleOpen,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_InfoOutlined__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    sx: {
                        color: "#89B1C6",
                        fontSize: 17,
                        transform: "translateY(3px)"
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_ui_components_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledPopper */ .kE, {
                open: popper.isOpen,
                anchorEl: anchorRef.current,
                handleClose: popper.handleClose,
                zIndex: 1200,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        padding: "1rem",
                        width: "300px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            fontSize: 14,
                            fontWeight: 600,
                            color: "#3A3E50",
                            pb: 1,
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                maxHeight: "200px",
                                marginTop: "10px",
                                overflow: "auto",
                                paddingInlineEnd: ".5rem"
                            },
                            className: "styled-scrollbar",
                            children: items.map(renderItem)
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoPopperList);


/***/ }),

/***/ 93704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);


var Label = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        color: "#8B8D98",
        fontSize: 10,
        fontWeight: 400,
        children: label
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Label);


/***/ }),

/***/ 38750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var VerticalDivider = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            width: "1px",
            height: "35px",
            backgroundColor: "#EAEEF6"
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VerticalDivider);


/***/ })

}]);